export default __webpack_public_path__ + "static/media/Modification.99ed9f56.jpg";